/*
 * 接口统一集成模块
 */
import * as home from "./home";
import * as manage from "./manage";
import * as nurse from "./nurse";
import * as dataBorad from "./dataBoard";
import * as security from "./security";
import * as rightSideBar from "./rightSideBar";

// 默认全部导出
export default {
  home,
  manage,
  nurse,
  dataBorad,
  security,
  rightSideBar,
};
